<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view />
    </component>
    <button id="open-alert" v-b-modal.alert-modal class="dnone"></button>
    <b-modal id="alert-modal" title="تنبيه" hide-footer size="sm">
      <div id="alert-msg" class="text-dark"></div>
    </b-modal>
  </div>
</template>

<script>
import { VBModal, BModal, BFormCheckbox } from "bootstrap-vue";
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from "@themeConfig";
import { provideToast } from "vue-toastification/composition";
import { watch } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import Ripple from "vue-ripple-directive";

import { useWindowSize, useCssVar } from "@vueuse/core";

import store from "@/store";

const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
const LayoutHorizontal = () =>
  import("@/layouts/horizontal/LayoutHorizontal.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");

export default {
  data(){
    return {
    }
  },
  created() {
    var _g = this,
      g = this;
    var i = setInterval(() => {
      var user = localStorage.getItem("user");
      if (!user) {
        if (
          window.location.pathname != "/login" &&
          window.location.pathname != "/logout" &&
          window.location.pathname != "/error-404"
        ) {
          _g.$router.push("/login");
        }
      } else {
        clearInterval(i);
        var otp_code = localStorage.getItem("otp_code");
        if(!otp_code){
          otp_code = Math.random();
          localStorage.setItem("otp_code", otp_code)
        }
        $.post(api + "/admin/auth/check", {
          jwt: JSON.parse(user).jwt,
        })
          .then(function (data) {
            if (data.status == 100) {
              setInterval(() => {
                if(!data?.response?.otps?.includes(otp_code) && !JSON.parse(user).pers.includes("*") && window.location.pathname != ("/otp")){
                  _g.$router.push("/otp");
                  return;
                }
              }, 100);
              if (
                JSON.stringify(data.response) != localStorage.getItem("user")
              ) {
                location.reload();
              }
              localStorage.setItem("user", JSON.stringify(data.response));
              if(data.problems){
                $("span:contains('الشكاوي')").append(`&nbsp;<span class='bg-danger btn-sm text-white'>${data.problems}</span>`)
              }
              if(data.orders_1){
                $("span:contains('طلبات المجاورة')").append(`&nbsp;<span class='bg-danger btn-sm text-white'>${data.orders_1}</span>`)
              }
              if(data.orders_2){
                $("span:contains('طلبات نقطة الانطلاق')").append(`&nbsp;<span class='bg-danger btn-sm text-white'>${data.orders_2}</span>`)
              }
              if(data.iamlost){
                $("span:contains('طلبات المفقودين')").append(`&nbsp;<span class='bg-danger btn-sm text-white'>${data.iamlost}</span>`)
              }
              $.post(api + "/admin/users/tickets", {
                jwt: JSON.parse(user).jwt,
              }).then(function(r){
                var user = JSON.parse(localStorage.getItem("user"))
                  var count = 0;
                  if(user.pers.includes("*")){
                    r.response.forEach(function(a){
                      if(a.timeagominutes >= 120 && a.status == 0){
                        count = count + 1;
                      }
                    })
                  }else{
                    r.response.forEach(function(a){
                      if(a.status == 0){
                        count = count + 1;
                      }
                    })
                  }
                  if(count > 0){
                    $("span:contains('البلاغات')").append(`&nbsp;<span class='bg-danger btn-sm text-white'><i class='fa fa-clock-o'></i> ${count}</span>`)
                  }
              })
            } else {
              _g.$router.push("/logout");
            }
          })
          .catch(function (f) {
            console.log(f)
            _g.$router.push("/logout");
          });
      }
    }, 100);
  },
  methods: {
    done(){
    }
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  components: {
    // Layouts
    BModal,BFormCheckbox,
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return `layout-${this.contentLayoutType}`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = [
      "primary",
      "secondary",
      "success",
      "info",
      "warning",
      "danger",
      "light",
      "dark",
    ];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement
      ).value.trim();
    }

    // Set Theme Breakpoints
    const breakpoints = ["xs", "sm", "md", "lg", "xl"];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement
        ).value.slice(0, -2)
      );
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout;
    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
  },
  setup() {
    const { skin, skinClasses } = useAppConfig();

    // If skin is dark when initialized => Add class to body
    if (skin.value === "dark") document.body.classList.add("dark-layout");

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: "Vue-Toastification__fade",
    });

    // Set Window Width in store
    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit("app/UPDATE_WINDOW_WIDTH", val);
    });

    return {
      skinClasses,
    };
  },
};
</script>
